import React, { useState, useEffect } from "react";
import "./Person.css";

import firebase from "firebase";
import { db, storage } from "../utils/User/include/Authorize";
import { useStateValue } from "../utils/Provider/StateProvider";

import { AiOutlineLoading3Quarters } from "react-icons/ai";
import RelativeMapHover from "./Hover/RelativeMapHover";

function Person(props) {
  const [{ user, myrelative, myfamily, mapRelativeDesc }, dispatch] =
    useStateValue();
  const [handleEdit, sethandleEdit] = useState(true);

  // Loading:
  const [savingImg, setSavingImg] = useState(false);

  // Handle Editing States:
  const [personName, setPersonName] = useState(props.details.name);
  const [relation_is, setRelationIs] = useState(
    `${
      props.details.relation_is === "custom"
        ? props.details.custom_relation
        : props.details.relation_is
    }`
  );
  const [icallHim, setICallHim] = useState(
    `${
      props.details.call_him === "custom"
        ? props.details.custom_call_him
        : props.details.call_him
    }`
  );
  const [married_with, setMarriedWith] = useState(props.details.married_to);
  const [dob, setDOB] = useState(props.details.DOB);
  const [location, setLocation] = useState(props.details.location_detail);
  const [contact, setContact] = useState(props.details.contact_detail);
  const [is_married, setIsMarried] = useState(props.details.is_married);
  const [aniversaryData, setAniversaryDate] = useState("");
  const [person_description, setPersonDescription] = useState(
    props.details.describe_person
  );
  const [known_as, setKnownAs] = useState(props.details.known_as);
  const [known_by, setKnownBy] = useState(props.details.known_by);
  const [imgSrc, setImgSrc] = useState(props.details.uploadProfileImg);

  const [errorNotify, setErrorNotify] = useState("💡 No Suggestions");
  const [newImage, setNewImage] = useState(false);
  const [showImage, setShowImage] = useState(false);

  // Handle Profile Images Here
  // const defaultImg = require('../resources/profile_default.png')
  const [profileurl, setProfileUrl] = useState("");
  const [profileurlDetails, setProfileURLDetails] = useState([]);
  const [uploadImage, setUploadImage] = useState(null);

  // const showStats = (name) => {
  useEffect(() => {
    if (user) {
      db.collection(user.email)
        .doc("peoples")
        .collection("images")

        .onSnapshot((snapshot) => {
          const data = [];
          snapshot.forEach((doc) => {
            let obj = doc.data();
            if (props.details.name === obj.name) {
              setProfileUrl(obj.url);
              obj["uuid"] = doc.id;
              setProfileURLDetails(obj);
            }
          });
        });
    } else {
      dispatch({
        type: "NOTIFY_ERROR",
        error: "Kindly, Login with your credentials !",
      });
    }
  }, []);

  // Set The color to the card:
  const setColor = (val, para) => {
    // For Relatives
    if (user && props.uuid) {
      console.log(props.uuid, props.personId, props.familyId);
      let sample = myrelative;
      const colorChange = (sample[props.familyId].person_data[
        props.personId
      ].bgcolor = para);

      db.collection(user.email)
        .doc("Relative")
        .collection("members")
        .doc(props.uuid)
        .update({ person_data: sample[props.familyId].person_data });
    }

    // For Family Members
    if (user && props.details.uuid) {
      console.log(props.details.uuid);

      db.collection(user.email)
        .doc("Family")
        .collection("members")
        .doc(props.details.uuid)
        .update({ bgcolor: para });
    }
  };

  // Delete the person from DB:
  const deletePerson = (para) => {
    let sample = myrelative;

    // FOR RELATIVES:
    if (user && props.personId) {
      console.log("DELETING...");
      const removePerson = sample[props.familyId].person_data;
      removePerson.splice(1, props.personId);

      db.collection(user.email)
        .doc("Relative")
        .collection("members")
        .doc(props.uuid)
        .update({ person_data: removePerson });
    }

    // FOR FAMILY MEMBERS:
    if (user && props.details.uuid) {
      db.collection(user.email)
        .doc("Family")
        .collection("members")
        .doc(props.details.uuid)
        .delete();
    }
  };

  // Save edit changes:
  const saveEdit = () => {
    console.log("saving the changes");

    if (!user) {
      alert("Login first");
      return;
    }

    if (personName === "") {
      alert("Name Field required");
    } else if (relation_is === "") {
      alert("Relationship Field is Required !");
    } else if (icallHim === "") {
      alert("Called as Field is Required !");
    } else if (is_married === "") {
      alert("Married Status is Required !");
    } else if (is_married === "yes" && married_with === "") {
      alert("Person is Married but 'Married with' Field is Empty ?");
    }
    // else if(is_married === "no" && married_with !== null){
    //     console.log(married_with, is_married)
    //     alert("Person is not Married so 'Married with' Field not Required !")
    // }
    else {
      // Edit My Realtives

      if (props.uuid) {
        let sample = myrelative;
        // Remove Old Person Record
        const removePerson = sample[props.familyId].person_data;
        removePerson.splice(props.personId, 1);

        // Add updated value of that person:
        let person_data = {
          family_name: props.details.family_name,
          name: personName,
          DOB: dob === "" ? null : dob,
          relation_is: relation_is === "" ? null : relation_is,
          custom_relation: null,
          call_him: icallHim === "" ? null : icallHim,
          custom_call_him: null,
          is_married: is_married,
          married_to: married_with === "" ? null : married_with,
          contact_detail: contact === "" ? null : contact,
          location_detail: location === "" ? null : location,
          describe_person: person_description,
          aniversary: aniversaryData === "" ? null : aniversaryData,
          bgcolor: props.details.bgcolor,

          uploadProfileImg: imgSrc,
          known_by: known_by,
          known_as: known_as,
        };

        removePerson.push(person_data);

        console.log("Relative Changing: ", person_data);
        console.log(removePerson);

        db.collection(user.email)
          .doc("Relative")
          .collection("members")
          .doc(props.uuid)
          .update({ person_data: removePerson })
          .catch((err) => console.log(err.message));
      }

      // FOR FAMILY MEMBERS:
      if (props.details.uuid) {
        // Add updated value of that person:
        let person_data = {
          family_name: props.details.family_name,
          name: personName,
          DOB: dob === "" ? null : dob,
          relation_is: relation_is === "" ? null : relation_is,
          custom_relation: null,
          call_him: icallHim === "" ? null : icallHim,
          custom_call_him: null,
          is_married: is_married,
          married_to: married_with === "" ? null : married_with,
          contact_detail: contact === "" ? null : contact,
          location_detail: location === "" ? null : location,
          describe_person: person_description,
          aniversary: aniversaryData === "" ? null : aniversaryData,
          bgcolor: props.details.bgcolor,
        };

        // 'family_name' : familyName,
        // 'name' : personName,
        // 'DOB' : DOB === '' ? null : DOB,
        // 'relation_is' : relation_is,
        // 'custom_relation' : custom_relation === '' ? null : custom_relation,
        // 'call_him' : IcallHim ,
        // 'custom_call_him' : custom_ICallHim === '' ? null : custom_ICallHim,
        // 'is_married': is_married,
        // 'married_to' : married_to === '' ? null : married_to,
        // 'contact_detail' : contact_detail === '' ? null : contact_detail,
        // 'location_detail' : location_detail === '' ? null : location_detail,
        // 'describe_person' : describe_person === '' ? null : describe_person,
        // 'bgcolor' : `${getColor()}`,
        // 'uploadProfileImg': [uploadImage === null ? 'default' : uploadImage[0]],
        // 'known_by': known_by,
        // 'known_as': known_as,
        // 'custom_knownas': custom_knownas === '' ? null : custom_knownas,
        // 'aniversary' : null

        // Updating DB:
        db.collection(user.email)
          .doc("Family")
          .collection("members")
          .doc(props.details.uuid)
          .update(person_data)
          .catch((err) => console.log(err.message));
      }

      // Handle Close:
      console.log("done");
      sethandleEdit(true);
      resetEditedFields();
    }
  };

  // Const Reset Edited Fields
  const resetEditedFields = () => {
    setPersonName(props.details.name);
    setRelationIs(
      `${
        props.details.relation_is === "custom"
          ? props.details.custom_relation
          : props.details.relation_is
      }`
    );
    setICallHim(
      `${
        props.details.call_him === "custom"
          ? props.details.custom_call_him
          : props.details.call_him
      }`
    );
    setMarriedWith(props.details.married_to);
    setDOB(props.details.DOB);
    setLocation(props.details.location_detail);
    setContact(props.details.contact_detail);
    setIsMarried(props.details.is_married);
    setPersonDescription(props.details.describe_person);
  };

  // Handle Edits of Profile Images:
  const EditImageofProfile = () => {
    if (uploadImage === null) {
      console.log(uploadImage);
      setErrorNotify("💡 Choose Image First");
      return;
    }

    setErrorNotify("✔️ No errors found");

    if (user && profileurlDetails.length !== 0) {
      setSavingImg(true);
      // Updating existing profile Img:

      // Performing Delete Actions
      const deleteTask = storage.ref(
        `${user.email}/people/${props.details.name}`
      );
      deleteTask.delete();
      console.log("deleted");

      // Perform Uppdate Action: in storage and db
      const uploadTask = storage
        .ref(`${user.email}/people/${props.details.name}`)
        .put(uploadImage[0]);

      console.log("updating");

      uploadTask.on(
        "state_changed",
        console.log("UPLOADING ..."),
        (error) => {
          console.log("uploading image Error >> ", error);
        },
        () => {
          storage
            .ref(`${user.email}/people/${props.details.name}`)
            .getDownloadURL()
            .then((url) => {
              profileurlDetails.url = url;
              console.log(url);
              db.collection(user.email)
                .doc("peoples")
                .collection("images")
                .doc(profileurlDetails.uuid)
                .update(profileurlDetails);

              setUploadImage(null);
              setNewImage(false);
              setSavingImg(false);
            })
            .catch((e) => {
              console.log(e);
              setSavingImg(false);
            });
        }
      );
    } else {
      // If the profile is default then :
      setSavingImg(true);

      // Perform Uppdate Action: in storage and db
      const uploadTask = storage
        .ref(`${user.email}/people/${props.details.name}`)
        .put(uploadImage[0]);
      console.log("updating");

      uploadTask.on(
        "state_changed",
        console.log("UPLOADING ..."),
        (error) => {
          console.log("uploading image Error >> ", error);
        },
        () => {
          storage
            .ref(`${user.email}/people/${props.details.name}`)
            .getDownloadURL()
            .then((url) => {
              profileurlDetails.url = url;
              console.log(url);
              db.collection(user.email)
                .doc("peoples")
                .collection("images")
                .add({ url: url, name: props.details.name });

              setUploadImage(null);
              setNewImage(false);
              setSavingImg(false);
            })
            .catch((e) => {
              dispatch({
                type: "NOTIFY_ERROR",
                error: e,
              });
              setSavingImg(false);
            });
        }
      );
    }
  };

  const check = (e) => {
    // console.log("check", e)
  };

  return (
    <div
      className="person_card_container"
      style={{
        border: `1px solid ${props.details.bgcolor}`,
        boxShadow: `0px 3px 10px 0px ${props.details.bgcolor}`,
        index: -1,
      }}
    >
      <div className="person_card_container_menu_option">
        <p>
          {props.familyId
            ? `${props.uuid}-${props.familyId}-${props.personId}`
            : props.details.uuid}
        </p>

        <div className="person_card_container_menu_vdot">
          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>

          <div className="person_card_container_menu_Hoveroption">
            <p>Options</p>
            {/* Hovering */}

            <div className="colours">
              {/* <div className='default' style={{ backgroundColor: 'rgb(230, 230, 230)' }}  onClick={() => setColor(props.details, 'rgb(230, 230, 230)')}></div> */}
              <div
                className="default"
                style={
                  props.details.bgcolor === "rgb(230, 230, 230)"
                    ? {
                        backgroundColor: "rgb(230, 230, 230)",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "rgb(230, 230, 230)" }
                }
                onClick={() => {
                  setColor(props.details, "rgb(230, 230, 230)");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "rgb(243, 125, 14)"
                    ? {
                        backgroundColor: "rgb(243, 125, 14)",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "rgb(243, 125, 14)" }
                }
                onClick={() => {
                  setColor(props.details, "rgb(243, 125, 14)");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "rgb(226, 35, 35)"
                    ? {
                        backgroundColor: "rgb(226, 35, 35)",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "rgb(226, 35, 35)" }
                }
                onClick={() => {
                  setColor(props.details, "rgb(226, 35, 35)");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "orangered"
                    ? {
                        backgroundColor: "orangered",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "orangered" }
                }
                onClick={() => {
                  setColor(props.details, "orangered");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "salmon"
                    ? {
                        backgroundColor: "orangered",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "salmon" }
                }
                onClick={() => {
                  setColor(props.details, "salmon");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "rgb(243, 239, 14)"
                    ? {
                        backgroundColor: "rgb(243, 239, 14)",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "rgb(243, 239, 14)" }
                }
                onClick={() => {
                  setColor(props.details, "rgb(243, 239, 14)");
                }}
              ></div>
            </div>

            <div className="colours" style={{ marginTop: "10px" }}>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "rgb(136, 255, 0)"
                    ? {
                        backgroundColor: "rgb(136, 255, 0)",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "rgb(136, 255, 0)" }
                }
                onClick={() => {
                  setColor(props.details, "rgb(136, 255, 0)");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "rgb(78, 172, 70)"
                    ? {
                        backgroundColor: "rgb(78, 172, 70)",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "rgb(78, 172, 70)" }
                }
                onClick={() => {
                  setColor(props.details, "rgb(78, 172, 70)");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "rgb(199, 12, 143)"
                    ? {
                        backgroundColor: "rgb(199, 12, 143)",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "rgb(199, 12, 143)" }
                }
                onClick={() => {
                  setColor(props.details, "rgb(199, 12, 143)");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "rgb(45, 124, 243)"
                    ? {
                        backgroundColor: "rgb(45, 124, 243)",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "rgb(45, 124, 243)" }
                }
                onClick={() => {
                  setColor(props.details, "rgb(45, 124, 243)");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "rgb(47, 187, 187)"
                    ? {
                        backgroundColor: "rgb(47, 187, 187)",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "rgb(47, 187, 187)" }
                }
                onClick={() => {
                  setColor(props.details, "rgb(47, 187, 187)");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "darkcyan"
                    ? {
                        backgroundColor: "darkcyan",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "darkcyan" }
                }
                onClick={() => {
                  setColor(props.details, "darkcyan");
                }}
              ></div>
            </div>

            <div className="colours">
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "rgb(226, 35, 153)"
                    ? {
                        backgroundColor: "rgb(226, 35, 153)",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "rgb(226, 35, 153)" }
                }
                onClick={() => {
                  setColor(props.details, "rgb(226, 35, 153)");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "rgb(226, 35, 226)"
                    ? {
                        backgroundColor: "rgb(226, 35, 226)",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "rgb(226, 35, 226)" }
                }
                onClick={() => {
                  setColor(props.details, "rgb(226, 35, 226)");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "gold"
                    ? {
                        backgroundColor: "gold",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "gold" }
                }
                onClick={() => {
                  setColor(props.details, "gold");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "goldenrod"
                    ? {
                        backgroundColor: "goldenrod",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "goldenrod" }
                }
                onClick={() => {
                  setColor(props.details, "goldenrod");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "rgb(194, 96, 51)"
                    ? {
                        backgroundColor: "rgb(194, 96, 51)",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "rgb(194, 96, 51)" }
                }
                onClick={() => {
                  setColor(props.details, "rgb(194, 96, 51)");
                }}
              ></div>
              <div
                className="choose_color"
                style={
                  props.details.bgcolor === "purple"
                    ? {
                        backgroundColor: "purple",
                        border: "3px solid rgb(111, 217, 252)",
                      }
                    : { backgroundColor: "purple" }
                }
                onClick={() => {
                  setColor(props.details, "purple");
                }}
              ></div>
            </div>

            <hr style={{ margin: "6px 0px" }} />

            <div className="person_card_container_menu_hoverBtn">
              <button onClick={() => sethandleEdit(false)}>
                <i class="fa fa-pencil" aria-hidden="true"></i> Edit
              </button>
              <button
                className="person_card_container_menu_hoverBtn_delete"
                onClick={() => deletePerson(props.details)}
              >
                <i class="fa fa-trash" aria-hidden="true"></i> Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <br />

      <div className="person_card_container_profile_img">
        {/* <img src={showStats(props.details.name)} alt='img' /> */}
        {/* profileurl */}
        <img
          src={
            profileurl
              ? profileurl
              : require("../resources/profile_default.png")
          }
          alt="img"
          onClick={() => setShowImage(true)}
        />

        <div className="editImage_btn" onClick={() => setNewImage(true)}>
          <label htmlFor="myInput">
            <i class="fa fa-pencil"></i>
          </label>
        </div>
      </div>
      <div
        className="person_card_container_bg_wall"
        style={{ backgroundColor: props.details.bgcolor }}
      ></div>

      <div className="person_card_container_records">
        <u>
          <p className="person_card_container_records_FamilyName">
            {props.details.family_name}
          </p>
        </u>

        <div className="person_card_container_records_row">
          <p className="person_card_container_records_title">Name: </p>

          {handleEdit ? (
            <p className="person_card_container_records_row_value">
              {props.details.name}
            </p>
          ) : (
            <p className="person_card_container_records_row_value">
              <input
                className="person_card_edit_option"
                type="text"
                placeholder="Person Name"
                value={personName}
                onChange={(e) => setPersonName(e.target.value)}
              />
              <input
                className="person_card_edit_option"
                type="text"
                placeholder="eg (father,son)"
                value={relation_is}
                onChange={(e) => setRelationIs(e.target.value)}
              />
            </p>
          )}
        </div>

        <div className="person_card_container_records_row">
          <p className="person_card_container_records_title">Called as : </p>
          {handleEdit ? (
            <p className="person_card_container_records_row_value">
              <b>
                {props.details.call_him === "custom" ? (
                  <RelativeMapHover relation={props.details.custom_call_him}>
                    {props.details.custom_call_him}
                  </RelativeMapHover>
                ) : (
                  <RelativeMapHover relation={props.details.call_him}>
                    <p
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                    >
                      {props.details.call_him}
                    </p>
                  </RelativeMapHover>
                )}
              </b>
            </p>
          ) : (
            <p className="person_card_container_records_row_value">
              <input
                className="person_card_edit_option"
                type="text"
                placeholder="You call him"
                value={icallHim}
                onChange={(e) => setICallHim(e.target.value)}
              />
            </p>
          )}
        </div>

        <div className="person_card_container_records_row">
          <p className="person_card_container_records_title">
            Married Status:{" "}
          </p>

          {handleEdit ? (
            <p className="person_card_container_records_row_value">
              {props.details.is_married}
            </p>
          ) : (
            <p className="person_card_container_records_row_value">
              <input
                className="person_card_edit_option"
                type="radio"
                value="yes"
                name="is_married"
                onClick={(e) => setIsMarried(e.target.value)}
                checked={is_married === "yes" ? "checked" : null}
              />{" "}
              Yes &nbsp;
              <input
                className="person_card_edit_option"
                type="radio"
                value="no"
                name="is_married"
                onClick={(e) => setIsMarried(e.target.value)}
                checked={is_married === "no" ? "checked" : null}
              />{" "}
              No
            </p>
          )}
        </div>

        <div className="person_card_container_records_row">
          <p className="person_card_container_records_title">Married with: </p>

          {handleEdit ? (
            <p className="person_card_container_records_row_value">
              {props.details.married_to === null
                ? "undefined"
                : props.details.married_to}
            </p>
          ) : (
            <p className="person_card_container_records_row_value">
              <input
                className="person_card_edit_option"
                type="text"
                placeholder="If Married"
                value={married_with}
                onChange={(e) => setMarriedWith(e.target.value)}
              />
            </p>
          )}
        </div>

        <div className="person_card_container_records_row">
          <p className="person_card_container_records_title">DOB: </p>

          {handleEdit ? (
            <p className="person_card_container_records_row_value">
              {props.details.DOB}
            </p>
          ) : (
            <p className="person_card_container_records_row_value">
              <input
                className="person_card_edit_option person_card_edit_option_date"
                type="date"
                placeholder="dd-mm-yyyy"
                min="1940-01-01"
                max="2050-1-1"
                value={dob}
                onChange={(e) => setDOB(e.target.value)}
              />
            </p>
          )}
        </div>

        <div className="person_card_container_records_row">
          <p className="person_card_container_records_title">Location: </p>

          {handleEdit ? (
            <p className="person_card_container_records_row_value">
              {props.details.location_detail === null
                ? "undefined"
                : props.details.location_detail}
            </p>
          ) : (
            <p className="person_card_container_records_row_value">
              <input
                className="person_card_edit_option"
                type="text"
                placeholder="Location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              />
            </p>
          )}
        </div>

        <div className="person_card_container_records_row">
          <p className="person_card_container_records_title">
            Contact Details:{" "}
          </p>

          {handleEdit ? (
            <p className="person_card_container_records_row_value">
              {props.details.contact_detail === null
                ? "undefined"
                : props.details.contact_detail}
            </p>
          ) : (
            <p className="person_card_container_records_row_value">
              <input
                className="person_card_edit_option"
                type="text"
                placeholder="Contact"
                value={contact}
                onChange={(e) => setContact(e.target.value)}
              />
            </p>
          )}
        </div>

        <div className="person_card_container_records_row">
          {handleEdit ? null : (
            <p className="person_card_container_records_row_value">
              <input
                className="person_card_edit_option"
                type="text"
                placeholder="Description"
                value={person_description}
                onChange={(e) => {
                  setPersonDescription(e.target.value);
                  check(props.details);
                }}
              />
            </p>
          )}
        </div>

        <div className="person_card_container_records_row">
          {handleEdit ? null : (
            <p className="person_card_container_records_row_value">
              Aniversary:{" "}
              <input
                className="person_card_edit_option"
                type="date"
                placeholder="Aniversary"
                value={aniversaryData}
                onChange={(e) => {
                  setAniversaryDate(e.target.value);
                  console.log(e.target.value);
                }}
              />
            </p>
          )}
        </div>
      </div>

      {handleEdit ? null : (
        <div className="person_card_save_editChanges">
          <button onClick={() => saveEdit()}>Save</button>
          <i class="fa fa-times" onClick={() => sethandleEdit(true)}></i>
        </div>
      )}

      {newImage ? (
        <div className="addfamily_modal_toggle">
          <div
            className="addfamily_modal_container"
            id="addfamily_modal_container"
          >
            <div className="addfamily_modal_content">
              <div className="addfamily_modal_content_header">
                <h3 className="addfamily_modal_content_title">Upload Image</h3>
                <span onClick={() => setNewImage(false)}>
                  <i class="fa fa-times fa-lg" aria-hidden="true"></i>
                </span>
              </div>

              <hr />

              <b>
                <p>choose File</p>
              </b>
              <br />
              <input
                type="file"
                onChange={(e) => setUploadImage(e.target.files)}
              />

              {/* <hr /> */}
              <br />
              <br />

              <div className="addfamily_modal_buttons">
                <span
                  id="verification_msg"
                  style={
                    errorNotify === "✔️ No errors found"
                      ? { backgroundColor: "rgb(88, 255, 88)" }
                      : null
                  }
                >
                  {errorNotify ? errorNotify : null}
                </span>
                <button
                  className="addfamily_person_btn"
                  onClick={() => EditImageofProfile()}
                >
                  {" "}
                  {savingImg && (
                    <AiOutlineLoading3Quarters className="loaderAnimation" />
                  )}{" "}
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {/* Show Image to model */}
      {showImage ? (
        <div className="display_person_container modal_background ">
          <div className="handle_image_display_img customize_image_modal_container display_person_container_content">
            <p>
              <i
                class="fa fa-times"
                arial-hidden="true"
                onClick={() => setShowImage(false)}
              ></i>
            </p>
            <img
              src={
                profileurl
                  ? profileurl
                  : require("../resources/profile_default.png")
              }
              alt="img"
              onClick={() => setShowImage(true)}
            />

            <p>
              <a
                className="handle_image_display_buttons"
                href={
                  profileurl
                    ? profileurl
                    : require("../resources/profile_default.png")
                }
                download={props.details.name}
              >
                Save
              </a>
              <button
                className="handle_image_display_buttons"
                onClick={() => {
                  setShowImage(false);
                  setNewImage(true);
                }}
              >
                Edit
              </button>
            </p>
          </div>
        </div>
      ) : null}

      {/* Add Member to family Component */}
    </div>
  );
}

export default Person;
